import { Injectable } from '@angular/core';
import { ClearActiveProject } from '../states/active-project-state/active-project.actions';
import { CreateProject } from '../states/projects-state/project.actions';
import { ProjectControllerService, ProjectWithRelations } from '@rappider/rappider-sdk';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class ProjectCreateService {

  constructor(
    private store: Store<any>,
    private projectControllerService: ProjectControllerService,
  ) { }

  /* Creates an empty project */
  createEmptyProject() {

    // clear the active project state and navigate to the project creation page
    this.store.dispatch(new ClearActiveProject());

    this.projectControllerService.find({ filter: { fields: ['name', 'key'] } }).subscribe(
      (projects: ProjectWithRelations[]) => {
        // filter the projects to get the person's projects
        const personProjects = projects;

        // find a new project name until it is unique
        let isUnique = false;
        let index = 1;
        const projectNamePrefix = 'My App';
        const projectKeyPrefix = 'my-app';
        let projectName = projectNamePrefix + ' ' + index;
        let projectKey = projectKeyPrefix + index;
        while (!isUnique) {
          isUnique = !personProjects.some(project => project.name === projectName) &&
            !personProjects.some(project => project.key === projectKey);
          if (!isUnique) {
            index++;
            projectName = projectNamePrefix + ' ' + index;
            projectKey = projectKeyPrefix + '-' + index;
          }
        }

        // generate an empty project data object
        const newProjectData = {
          appType: 'web',
          backendFramework: 'loopback4',
          categoryIds: [],
          description: '',
          frontendFramework: 'angular',
          hasAuthenticationModule: true,
          hasPaymentModule: false,
          isCreatedByAI: false,
          key: projectKey,
          targetAudienceDescription: '',
          name: projectName
        };

        // dispatch the action to create a new project
        this.store.dispatch(new CreateProject({ project: newProjectData }));
      },
      error => {
        console.error('Error fetching projects:', error);
      });

  }
}
